import React from 'react';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import * as styles from './IrisPage.css';

const cx = classNames.bind(styles);

export default (item, key) => {
    /* istanbul ignore next */
    const getComponentPaddingBottom = (items = 'NA', deviceType = {}) => {
        const { isDesktop = true } = deviceType;
        if (isDesktop) {
            switch (items.toUpperCase()) {
                case 'XS':
                    return 16;
                case 'NONE':
                    return 0;
                case 'SM':
                    return 24;
                case 'MD':
                    return 40;
                case 'LG':
                    return 60;
                default:
                    return 16;
            }
        } else {
            switch (items.toUpperCase()) {
                case 'XS':
                    return 8;
                case 'NONE':
                    return 0;
                case 'SM':
                    return 16;
                case 'MD':
                    return 24;
                case 'LG':
                    return 40;
                default:
                    return 16;
            }
        }
    };

    /* istanbul ignore next */
    const isfetchComponentPadding = (items) => {
        const {
            featureFlags: { enableComponentPadding: enableComponentPaddingVal = true } = {},
            bottomMargin = '',
            componentType = '',
            deviceType = {},
            preferences: { componentIgnorePadding: componentIgnorePaddingVal = [] } = {},
        } = items;

        if (
            isEmpty(bottomMargin) ||
            componentIgnorePaddingVal.indexOf(componentType) > -1 ||
            !enableComponentPaddingVal
        ) {
            return {};
        }
        return { marginBottom: getComponentPaddingBottom(bottomMargin, deviceType) };
    };

    const isFullBleed = item && item.props.fullBleed;
    const isDHTMLHomeComponet =
        item &&
        item.props.pageType === 'HOME' &&
        item.props.componentType === 'dhtml' &&
        !item.props.bottomMargin;
    const dhtmlComponentClass = isDHTMLHomeComponet ? 'dhtmlComponentWrapper' : '';
    const widthClass =
        isFullBleed && item.props.pageType === 'HOME' ? 'fullwidthComp' : 'regularWidthComp';
    return item ? (
        <div
            style={isfetchComponentPadding(item.props)}
            className={cx(widthClass, dhtmlComponentClass)}
            id={item?.key || key}
        >
            {item}
        </div>
    ) : null;
};
